// Audio volume adapter for user-normalized volume settings

export const AUDIO_MAX_GAIN = {
  speechVolume: 1,
  musicVolume: 0.5,
  sfxVolume: 0.5,
} as const;

export type AudioVolumeKey = keyof typeof AUDIO_MAX_GAIN;

export function userVolumeToGain(
  key: AudioVolumeKey,
  userVolume: number
): number {
  const clampedUserVolume = Math.max(0, Math.min(1, userVolume));
  return clampedUserVolume * AUDIO_MAX_GAIN[key];
}
